
import styled from "styled-components"
import IsletmeItem from "./IsletmeItem"
import { useSelector } from "react-redux"
import InputPlacesForYellowPages from "../shared/customInput/InputPlacesForYellowPages"
import InputSelect from "../shared/input/new/InputSelect"
import useWindowDimensions from "../../hooks/useWindowSize"

const Container = styled.div`
    height: 100vh;
    width: 420px;
    border-right: 1px solid ${({theme}) => theme.mainTextColor};
    padding: 30px 0;

    .top-container{
      width: 100%;
      margin-bottom: 30px;
      padding-left: 20px;

      h1{
        font-size: var(--font-size-lg);
        font-weight: var(--font-weight-xl);
      }
    }

    .location-container{
      width: 100%;
      margin-bottom: 30px;
      padding: 0 20px;
    }
    .list-container{
      display: flex;
      flex-direction: column;

      .list-top-container{
        margin-bottom: 20px;
        padding-left: 20px;

        h4{
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
        }
      }

      .list{
        display: flex;
        flex-direction: column;
        overflow: auto;
        max-height: calc(100vh - 120px);

        &::-webkit-scrollbar {
          width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #9e9b9b;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }

        .list-item{
          display: flex;
          flex-direction: column;
          padding: 20px 0;
          gap: 5px;
          border-bottom: 1px solid ${({theme}) => theme.mainBorderColor};

          .isletme-name{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
          }

          .isletme-rating{
            display: flex;
            align-items: center;
            gap: 5px;
            font-weight: var(--font-weight-lg);
            font-size: var(--font-size-sm);
          }

          .isletme-data{
            font-weight: var(--font-weight-md);
            font-size: var(--font-size-sm);
          }

          .isletme-opening-data{
            display: flex;
            align-items: center;
            gap: 10px;
            
            .isletme-is-open-green{
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-lg);
              color: var(--color-green);
            }
            
            .isletme-is-open-red{
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-lg);
              color: var(--color-red);
            }

            .date-time{
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-md);
              color: ${({theme}) => theme.secondaryTextColor};
            }

          }
        }
      }
    }

    @media (max-width: 1450px) {
      width: 350px;
    }

    @media (max-width: 1100px) {
      border: none;
      width: 100%;
      height: auto !important;

    .location-container{
      display: flex;
      flex-direction: column;
      gap: 20px;
    }

      .list{
        height: auto !important;
        max-height: none !important;
      }
  }
`

const YellowPagesIsletmeSide = ({setActiveMenu, activeMenu, menuList, setActivePoint}) => {

    const {isletmeList, yellowPageLocation} = useSelector(state => state.yellowPages)
    const {windowDimensions} = useWindowDimensions()

  return (
    <Container>
        <div className="top-container">
          <h1>Güvenli Park Yerleri</h1>
        </div>
        <div className="location-container">
          {
            windowDimensions.width <= 700 &&
            <InputSelect data={activeMenu.text} setData={setActiveMenu} labelText={"Arama Türü Seçin"} inputWidth={"100%"} initialOptions={menuList}/>
          }
          <InputPlacesForYellowPages labelText={"Adres Girin"} inputWidth={"100%"} name={"yellowPagesAdresInput"} location={yellowPageLocation}/>
        </div>
        <div className="list-container">
          <div className="list-top-container">
              <h4>Sonuçlar</h4>
          </div>
          <div className="list">
            {
              isletmeList?.map((item, i) => (
                <IsletmeItem item={item} key={i} setActivePoint={setActivePoint}/>
              ))
            }
          </div>
        </div>
    </Container>
  )
}

export default YellowPagesIsletmeSide